import Route from '@ember/routing/route';

class AdminReportsRoute extends Route {
  /**
   * @inheritDoc
   */
  model() {
    return {
      reports: null,
    };
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    controller.loadReports.perform();
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.loadReports.cancelAll();
    }
  }
}

export default AdminReportsRoute;
